'use strict';

import angular from 'angular';
import DashboardController from './controller/dashboard';
import PrintController from './controller/print';
import MetricFilterDirective from './directive/metricFilter';
import DashboardInfo from './directive/dashboardInfo';
import MetricFilterIndicatorDirective from './directive/metricFilterIndicator';
import SimpleMetric from './directive/simpleMetric';
import ProgressMetric from './directive/progressMetric';
import ChartOptionsService from './service/chartOptions';
import DashboardFiltersService from './service/dashboardFilters';
import PrintService from './service/printService';
import MetricService from './service/metric';
import nnMapDirective from './directive/nnMap';
import summaryCharts from './directive/summaryCharts';

export default angular.module('investmentProject.dashboard', ['chart.js'])
    .controller('DashboardController', DashboardController)
    .controller('PrintController', PrintController)

    .directive('metricFilter', MetricFilterDirective)
    .directive('metricFilterIndicator', MetricFilterIndicatorDirective)
    .directive('simpleMetric', SimpleMetric)
    .directive('progressMetric', ProgressMetric)
    .directive('dashboardInfo', DashboardInfo)
    .directive('nnMap', nnMapDirective)
    .directive('summaryCharts', summaryCharts)

    .factory('MetricService', MetricService)
    .factory('DashboardFiltersService', DashboardFiltersService)
    .factory('ChartOptionsService', ChartOptionsService)
    .factory('PrintService', PrintService)
    .name;
